import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Stack, UnstyledButton } from "@mantine/core";
import { useResponsive } from "hooks/useResponsive";
import classes from "./LeftToggle.module.css";

const TOGGLE_HEIGHT = 56; // px, also in LeftToggle.module.css
const ICON_RIGHT_PADDING = 3; // px

type Props = {
  handleToggle: (e: React.MouseEvent<HTMLElement>) => void;
  isOpen: boolean;
};

export const LeftToggle = ({ handleToggle, isOpen }: Props) => {
  const { isSm } = useResponsive();

  return (
    <UnstyledButton
      onClick={handleToggle}
      mt={-(TOGGLE_HEIGHT / 2)}
      pr={ICON_RIGHT_PADDING}
      className={classes.toggle}
    >
      {!isSm && (
        // touch thumb on small devices
        <Box
          onClick={handleToggle}
          style={{
            position: "absolute",
            top: -15,
            bottom: -15,
            right: -15,
            left: 0,
            borderRadius: 15,
          }}
        />
      )}
      <Stack
        style={{
          transform: isOpen ? "" : "rotate(180deg)",
          transition: "transform 0.5s",
        }}
      >
        <FontAwesomeIcon icon={faChevronLeft} />
      </Stack>
    </UnstyledButton>
  );
};
